// export default {
//   NO_DECLARATION: 'NO_DECLARATION',
//   FINAL_DECLARATION: 'FINAL_DECLARATION',
//   DECLARATIONS: 'DECLARATIONS',
// }

export const NO_DECLARATION = 'NO_DECLARATION';
export const FINAL_DECLARATION = 'FINAL_DECLARATION';
export const DECLARATIONS = 'DECLARATIONS';
